module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "nist-influx--dataset-cover.ecc6247d.png";